"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var DistrictNameInput_vue_1 = __importDefault(require("../form/DistrictNameInput.vue"));
var VInlineInputEditor_vue_1 = __importDefault(require("../scraps/VInlineInputEditor.vue"));
var event_bus_1 = require("../../event-bus");
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var DeleteDistrict_vue_1 = __importDefault(require("./DeleteDistrict.vue"));
var __ = window.$lang;
exports.default = vue_1.default.extend({
    name: "districts-table",
    components: {
        DeleteDistrict: DeleteDistrict_vue_1.default,
        VInlineInputEditor: VInlineInputEditor_vue_1.default,
        VIcon: VIcon_vue_1.default
    },
    props: {
        districts: {
            type: Array,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            permissions: permissions_json_1.default,
            headers: [
                __("Lp."),
                __("Nazwa hufca"),
                __("Akcje")
            ],
            components: {
                DistrictNameInput: DistrictNameInput_vue_1.default
            }
        };
    },
    methods: {
        onDistrictRename: function (district_id, name) {
            event_bus_1.EventBus.$emit(event_bus_1.events.district.rename, {
                id: district_id,
                name: name
            });
        }
    }
});
